<template>
  <page-layout>
    <figure-animate height-content="h-full lg:h-screen h-fit flex
      justify-around flex-wrap items-center px-10 pb-28 pt-20 lg:pt-10 md:py-0">
      <div class="flex items-center flex-col
      justify-center relative md:w-1/2 w-full">
        <div class="absolute h-1/2 w-1/2 bg-white section-right"></div>
         <Vue3Lottie
            :animationData="LottiePortfolio"
            :height="400"
            :width="400"/>
      </div>
      <div class=" md:w-1/2 w-full flex justify-center flex-col items-center text-center">
        <h2 class="text-white text-8xl text-shadow-pop-left">{{$t('Im')}}</h2>
        <v-typical v-show="$i18n.locale === 'en'"
          class="blink text-white text-6xl text-shadow-pop-left"
          :steps="[
            'Jesús A. Varela C.', 2000,
            'a Software Developer', 2000,
            'a Freelancer', 2000,
            'from Venezuela', 2000]"
          :loop="Infinity"
          :wrapper="'h2'"
        ></v-typical>
        <v-typical v-show="$i18n.locale === 'es'"
          class="blink text-white text-6xl text-shadow-pop-left"
          :steps="[
            'Jesús A. Varela C.', 2000,
            'un Desarrollador de Software', 2000,
            'un Freelancer', 2000,
            'de Venezuela', 2000]"
          :loop="Infinity"
          :wrapper="'h2'"
        ></v-typical>
      </div>
    </figure-animate>
  </page-layout>
</template>

<script>
import FigureAnimate from '@/components/FigureAnimate.vue';
import VTypical from 'vue-typical';
import PageLayout from '@/layouts/PageLayout.vue';
import Vue3Lottie from 'vue3-lottie';
import LottiePortfolio from '@/assets/lotties/portfolio2.json';

export default {
  name: 'Home',
  components: {
    FigureAnimate,
    VTypical,
    PageLayout,
    Vue3Lottie,
  },
  data() {
    return {
      LottiePortfolio,
      description: [],
    };
  },
  created() {
    this.$store.dispatch('UPDATE_TITLE_STATE', { value: '' });
    this.description.push('Jesús A. Varela C.');
  },
  computed: {
  },
};
</script>
<style scoped>

  .logo{
    z-index:0;
  }
  div.section-right {
    border-radius: 36% 64% 49% 51% / 79% 45% 55% 21%  ;
    box-sizing: border-box;
  }
  .blink::after {
  content: '|';
  animation: blink 1s infinite step-start;
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
</style>
